// Socket events are the only ML status trigger for scopes owned by a realtime
// owner. The offline sync layer may only fetch a report when the images it
// describes are already registered server-side; fetching earlier is a
// guaranteed 503 because the report cannot exist yet, and the realtime
// owner's socket-driven resync hydrates the row once images land.
export const patientHasServerImages = (patient) =>
  Boolean(patient?.imgOnServer) && Boolean(patient?.imgDataOnServer);

export const isNotReadyReportError = (error) =>
  error?.response?.status === 503;

export default patientHasServerImages;
